// extracted by mini-css-extract-plugin
module.exports = {"container":"Avatar_container__cAorw","under_text":"Avatar_under_text__VP1I9","right_text":"Avatar_right_text__1UTnY","avatarWarper":"Avatar_avatarWarper__29J6I"};